import OrphanAssignmentItem from '../Domain/OrphanAssignmentItem';
import OrphanedAssignmentsClientGroupedItem from '../Domain/OrphanedAssignmentsClientGroupedItem';
import OrphanedAssignmentsProjectGroupedByClientItem from '../Domain/OrphanedAssignmentsProjectGroupedByClientItem';
import OrphanedAssignmentsProjectGroupedByOfficeItem from '../Domain/OrphanedAssignmentsProjectGroupedByOfficeItem';
import AuthService from './authService';
import SearchParams from '../Elements/SearchParams';
import OrphanedAssignmentSearchParams from '../Contents/Operations/Assignments/OrphanedAssignment/OrphanedAssignmentSearchParams';
import OrphanedMissingDateAssignmentSearchParams from '../Contents/Operations/Assignments/OrphanedAssignment/OrphanedMissingDateAssignmentSearchParams';

export default class OrphanedAssignmentService {
  static GetOrphanedAssignmentsClientGrouped(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: 'OrphanedAssignmentsClientGrouped',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetOrphanedAssignmentsClientGroupedAsync/?searchParams=${JSON.stringify(
        searchParams
      )}&clearCache=${clearCache}`
    );
  }

  static ConvertOrphanedAssignmentsClientGroupedDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OrphanedAssignmentsClientGroupedItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetOrphanedAssignmentsProjectGroupedByOffice(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: 'OrphanedAssignmentsProjectGroupedByOffice',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetOrphanedAssignmentsProjectGroupedByOfficeAsync/?searchParams=${JSON.stringify(
        searchParams
      )}&clearCache=${clearCache}`
    );
  }

  static ConvertOrphanedAssignmentsProjectGroupedByOfficeDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OrphanedAssignmentsProjectGroupedByOfficeItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetOrphanedAssignmentsProjectGroupedByClient(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: 'OrphanedAssignmentsProjectGroupedByClient',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetOrphanedAssignmentsProjectGroupedByClientAsync/?searchParams=${JSON.stringify(
        searchParams
      )}&clearCache=${clearCache}`
    );
  }

  static ConvertOrphanedAssignmentsProjectGroupedByClientDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OrphanedAssignmentsProjectGroupedByClientItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetAssignmentListOrphanClient(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, OrphanedAssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements, 'AssignmentListOrphanClient');
    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetAssignmentListOrphanClientAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static GetAssignmentListOrphanProject(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, OrphanedAssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements, 'AssignmentListOrphanProject');
    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetAssignmentListOrphanProjectAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static GetAssignmentListOrphanCompletedDate(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, OrphanedMissingDateAssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements, 'AssignmentListOrphanCompletedDate');
    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetAssignmentListOrphanCompletedDateAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertOrphanAssignmentDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OrphanAssignmentItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }
}
